import React, { PropTypes } from "react";
import { Field } from "redux-form";
import { FormattedMessage } from "react-intl";

import { BILLING_PERIOD } from "../../../enums/ratePeriodTypes";

import FixedFormula from "./formulas/FixedFormula";
import SalaryFormula from "./formulas/SalaryFormula";

import { RadioGroup } from "../../../../../common/form";

const FormulaTypeCoverage = (props) => {
  const Formula = () => {
    switch (props.formulaType) {
      case "SALARY":
        return (
          <SalaryFormula
            languageCode={props.languageCode}
            ratePeriodType={props.ratePeriodType}
            onChangeClientRate={props.onChangeClientRate}
            readOnly={props.readOnly}
          />
        );

      case "FIXED":
      default:
        return (
          <FixedFormula
            ratePeriodType={props.ratePeriodType}
            onChangeClientRate={props.onChangeClientRate}
            readOnly={props.readOnly}
          />
        );
    }
  };

  return (
    <div>
      <h3>{<FormattedMessage id="clientCoverages.form.formulaRate" />}</h3>
      {props.ratePeriodType === BILLING_PERIOD.value && (
        <p className="text-primary">
          <FormattedMessage id="clientCoverages.form.warnings.billingPeriodRate" />
        </p>
      )}
      <div className="type-table">
        <div className="row formula-type">
          <div className="cell">
            <h5>{<FormattedMessage id="clientCoverages.form.formula" />}</h5>
          </div>

          <div className="cell">
            <span>
              {<FormattedMessage id="clientCoverages.form.formulaVolume" />} /{" "}
              {props.volume} *{" "}
              {<FormattedMessage id="clientCoverages.form.rate" />}
            </span>
          </div>
        </div>

        <div className="row formula-type">
          <div className="cell">
            <h5>
              {<FormattedMessage id="clientCoverages.form.volumeCalculation" />}
            </h5>
          </div>

          <div className="cell">
            <Field
              props={{ onChange: props.onFormulaTypeSelect }}
              id="formulaType"
              name="formulaType"
              component={RadioGroup}
              disabled={props.readOnly}
              radios={[
                {
                  value: "FIXED",
                  text: <FormattedMessage id="clientCoverages.form.fixed" />,
                },
                {
                  value: "SALARY",
                  text: (
                    <FormattedMessage id="clientCoverages.form.perAnnualSalary" />
                  ),
                },
              ]}
            />
          </div>
        </div>
      </div>

      {Formula()}
    </div>
  );
};

FormulaTypeCoverage.propTypes = {
  volume: PropTypes.number,
  onFormulaTypeSelect: PropTypes.func,
  formulaType: PropTypes.string,
  ratePeriodType: PropTypes.string,
  languageCode: PropTypes.string,
  onChangeClientRate: PropTypes.func,
  readOnly: PropTypes.bool,
};

export default FormulaTypeCoverage;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/client-coverages/priceCalculation/FormulaTypeCoverage.js